import { useEffect } from 'react';
import { Outlet } from 'react-router';

import { useActions } from '@shared/lib/hooks/useActions';

export const UserContextLayout = () => {
	const { activatePrivateContext } = useActions();

	useEffect(() => {
		activatePrivateContext();
	}, []);

	return <Outlet />;
};
